const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectedS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.823529%,21.960784%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 36 18 C 36 27.941406 27.941406 36 18 36 C 8.058594 36 0 27.941406 0 18 C 0 8.058594 8.058594 0 18 0 C 27.941406 0 36 8.058594 36 18 Z M 36 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18 12.289062 C 14.847656 12.289062 12.289062 14.847656 12.289062 18 C 12.289062 21.152344 14.847656 23.710938 18 23.710938 C 21.152344 23.710938 23.710938 21.152344 23.710938 18 C 23.710938 14.847656 21.152344 12.289062 18 12.289062 Z M 20.066406 19.445312 C 20.238281 19.617188 20.238281 19.894531 20.066406 20.066406 C 19.894531 20.238281 19.617188 20.238281 19.445312 20.066406 L 18 18.621094 L 16.554688 20.066406 C 16.382812 20.238281 16.105469 20.238281 15.933594 20.066406 C 15.761719 19.894531 15.761719 19.617188 15.933594 19.445312 L 17.378906 18 L 15.933594 16.554688 C 15.761719 16.382812 15.761719 16.105469 15.933594 15.933594 C 16.105469 15.761719 16.382812 15.761719 16.554688 15.933594 L 18 17.378906 L 19.445312 15.933594 C 19.617188 15.761719 19.894531 15.761719 20.066406 15.933594 C 20.238281 16.105469 20.238281 16.382812 20.066406 16.554688 L 18.621094 18 Z M 20.066406 19.445312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedS);
export default __webpack_public_path__ + "static/media/rejected_s.5e670bcb279e0a4697b99be7f4d4084a.svg";
export { ForwardRef as ReactComponent };